export const assetsTypeList = [
    {
        value: '评估',
        label: '评估',
        children: [
            {
                value:1,
                label:'物损评估'
            },
            {
                value:2,
                label:'车辆评估'
            },
        ],
    },{
        value: '调查',
        label: '调查',
        children: [
            {
                value:5,
                label:'车险'
            },
        ],
    },
    // {
    //     value: '财产险',
    //     label: '财产险',
    //     children: [
    //         {
    //             value:6,
    //             label:'企财险'
    //         },
    //         {
    //             value:7,
    //             label:'家财险'
    //         },
    //         {
    //             value:16,
    //             label:'责任险'
    //         },
             
    //         {
    //             value:8,
    //             label:'工程机械设备险'
    //         },
    //         {
    //             value:14,
    //             label:'建工险'
    //         },
    //         {
    //             value:15,
    //             label:'船舶险'
    //         },
    //         {
    //             value:9,
    //             label:'货运险'
    //         },
    //         {
    //             value:10,
    //             label:'农险'
    //         },
    //         {
    //             value:11,
    //             label:'风险咨询'
    //         },{
    //             value:12,
    //             label:'其他'
    //         },
    //     ],
    // }
]

export const assetsTypeList13 = [
    {
        value: '评估',
        label: '评估',
        children: [
            {
                value:1,
                label:'物损评估'
            },
            {
                value:2,
                label:'车辆评估'
            },
            {
                value:3,
                label:'其他评估'
            },
        ],
    },{
        value: '调查',
        label: '调查',
        children: [
            {
                value:4,
                label:'财产险'
            },{
                value:5,
                label:'车险'
            },{
                value:13,
                label:'其他调查'
            },
        ],
    }
]

export const assetsTypeList2 = [
    {
        value: '财产险',
        label: '财产险',
        children: [
            {
                value:6,
                label:'企财险'
            },
            {
                value:7,
                label:'家财险'
            },
            {
                value:8,
                label:'工程机械险'
            },
            {
                value:9,
                label:'货运险'
            },
            {
                value:10,
                label:'农险'
            },
            {
                value:11,
                label:'风险咨询'
            },{
                value:12,
                label:'其他'
            },
        ],
    }
]


export const assetsStateList = [
    {
        value: 10,
        label: '已指派待作业',
    },{
        value: 20,
        label: '作业中',
    },{
        value: 30,
        label: '待审核',
    },{
        value: 35,
        label: '审核退回',
    },{
        value: 102,
        label: '审核通过',
    }
    ,{
        value: 101,
        label: '待归档',
    }
    // ,{
    //     value: 40,
    //     label: '待归档',
    // }
    // ,{
    //     value: 60,
    //     label: '待归档',
    // },{
    //     value: 65,
    //     label: '归档审核',
    // }
    // ,{
    //     value: 64,
    //     label: '归档不通过',
    // }
    ,{
        value: 100,
        label: '完成',
    },{
        value: 110,
        label: '取消委托',
    }

   
]

export const FinancialStateList = [
    {
        value: 10,
        label: '已开票未回款',
    },{
        value: 15,
        label: '已开票部分回款',
    },{
        value: 20,
        label: '回款完成',
    },{
        value: 25,
        label: '已收款未开票',
    },{
        value: 0,
        label: '其他',
    }
    ,{
        value: 30,
        label: '红冲',
    }
   

   
]


export const auditStateList = [
    {
        value: 10,
        label: '分公司待审核',
    },{
        value: 15,
        label: '分公司审核退回',
    },{
        value: 30,
        label: '总部待审核',
    },{
        value: 40,
        label: '总部审核不通过',
    },{
        value: 50,
        label: '总部审核通过',
    },{
        value: 70,
        label: '归档待审核',
    },{
        value: 80,
        label: '归档审核通过',
    },{
        value: 90,
        label: '归档审核不通过',
    },{
        value: 15,
        label: '已作业待审核',
    }
    // ,{
    //     value: 60,
    //     label: '完成',
    // }
]
export const auditStateListC = [
    {
        value: 10,
        label: '分公司待审核',
    },{
        value: 15,
        label: '分公司审核退回',
    },{
        value: 30,
        label: '分公司审核通过',
    }
    ,{
        value: 30,
        label: '已作业待审核',
    }
]

export const auditingStateList = [
    {
        value: 10,
        label: '一级待审核',
    },{
        value: 20,
        label: '二级待审核',
    },{
        value: 40,
        label: '用印待审核',
    }
]

export const noAuditStateList = [
    {
        value: 15,
        label: '一级审核不通过',
    },{
        value: 25,
        label: '二级审核不通过',
    },{
        value: 45,
        label: '用印审核不通过',
    }
]

export const delegationTypeList = [
    {
        value: 1,
        label: '保险主体',
    },{
        value: 2,
        label: '公检法',
    },{
        value: 3,
        label: '社会个体',
    }
]
export const dangerList = [
    '火灾',
    '爆炸',
    '雷击',
    '暴雨',
    '暴风',
    '龙卷风',
    '台风',
    '沙尘暴',
    '暴雪',
    '冰凌',
    '冰雹',
    '泥石流、崩塌、滑坡',
    '地陷',
    '地震',
    '海啸',
    '其他自然灾害',
    '空中物体坠落',
    '意外事故',
    '过失行为',
    '水箱、水管爆裂',
    '自燃',
    '盗窃、抢劫',
    '供应中断',
    '营业中断',
    '虫蛀、鼠咬',
    '机器故障',
    '操作失误',
    '超负荷、超电压',
    '运输工具碰撞、倾覆、坠落',
    '隧道、桥梁、码头坍塌',
    '驳运工具搁浅、触礁、沉没、碰撞',
    '运输过程碰撞、挤压',
    '雨淋',
    '船舶碰撞、触碰',
    '船舶搁浅、触礁',
    '螺旋桨、舵、锚、锚链及子船单独损失',
    '货物短量',
    '货物提货不着',
    '产品缺陷',
    '供电线路断路、短路、搭错线',
    '供电线路电压不符标准',
    '其他',


]
export const entrustedProjectList = [
    '仅查勘',
    '仅定损',
    '查勘定损',
    '调查',
    '全案委托',
    '风险咨询',
]
export const assessStatusList = [
    '房屋建筑物',
    '机器设备',
    '车辆',
    '道路交通设备',
    '其他物损',
]
export const assessPurposeList = [
    '诉讼',
    '询价',
    '保险理赔',
]

export const caseComeList = [
    {
        value: "价格评估",
        label: '价格评估',
    },{
        value: "安全评价",
        label: '安全评价',
    }
]